type Option = { label: string; value: string };

export const buildYearOptions = (range = 100): Option[] => {
	const currentYear = new Date().getFullYear();

	const years: Option[] = Array.from({ length: range }, (_, i) => {
		const y = String(currentYear - i);
		return { label: y, value: y };
	});

	return [{ label: 'Selecciona año', value: '' }, ...years];
};

export const buildTomoOptions = (max = 64): Option[] => {
	const pad3 = (n: number) => String(n).padStart(3, '0');

	const tomos: Option[] = Array.from({ length: max }, (_, i) => {
		const value = `TOMO-${pad3(i + 1)}`;
		return { label: value, value };
	});

	return [{ label: 'Selecciona tomo', value: '' }, ...tomos];
};
